import * as moment from 'moment-timezone';

import { Event, EVENT_STATUS } from '../models/event';

export const isEventEnded = (event?: Event) => moment(event?.end_time).isBefore(moment());
export const isEventCancelled = (event?: Event) => event?.state?.status === EVENT_STATUS.CANCELLED;
export const isEventCompleted = (event?: Event) => event?.state?.status === EVENT_STATUS.COMPLETED;
